import { render, staticRenderFns } from "./BMVideoTile.vue?vue&type=template&id=2fe083d3&"
import script from "./BMVideoTile.vue?vue&type=script&lang=js&"
export * from "./BMVideoTile.vue?vue&type=script&lang=js&"
import style0 from "./BMVideoTile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BMVideoTile.vue"
export default component.exports